var _defs, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_360",
    "data-name": "Groupe 360",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 31.353,
    height: 39.928,
    fill: "#3ac1ae"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 39.5,
    cy: 39.5,
    r: 39.5,
    transform: "translate(0 0)",
    fill: "#d9fdf9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_113",
    "data-name": "Groupe 113",
    transform: "translate(23.824 20.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_113-2",
    "data-name": "Groupe 113",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_536",
    "data-name": "Trac\\xE9 536",
    d: "M26.36,0H4.993A5,5,0,0,0,0,4.993V28.548A5,5,0,0,0,3.824,33.4v3.565a2.965,2.965,0,0,0,2.962,2.961H24.568a2.965,2.965,0,0,0,2.961-2.961V33.4a5,5,0,0,0,3.824-4.854V4.993A5,5,0,0,0,26.36,0M19.819,6H11.534V2.34h8.285Zm-16-1.013V30.93A2.657,2.657,0,0,1,2.34,28.548V4.993A2.657,2.657,0,0,1,4.993,2.34h4.2V3.7H5.111A1.288,1.288,0,0,0,3.824,4.991M25.19,36.966a.623.623,0,0,1-.622.622H6.785a.623.623,0,0,1-.622-.622V6.043H9.195V7a1.342,1.342,0,0,0,1.34,1.34H20.818A1.342,1.342,0,0,0,22.159,7v-.96H25.19Zm3.824-8.418a2.657,2.657,0,0,1-1.484,2.381V4.991A1.288,1.288,0,0,0,26.242,3.7H22.159V2.34h4.2a2.657,2.657,0,0,1,2.654,2.654Z",
    fill: "#3ac1ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_537",
    "data-name": "Trac\\xE9 537",
    d: "M144.944,150.513a13.866,13.866,0,0,0-1.627-.94q-.877-.433-1.627-.719a3.974,3.974,0,0,1-1.258-.74,1.391,1.391,0,0,1-.507-1.067,1.377,1.377,0,0,1,.623-1.194,3.07,3.07,0,0,1,1.765-.433,4.333,4.333,0,0,1,1.881.4,3.977,3.977,0,0,0,1.035.4.9.9,0,0,0,.8-.5,1.919,1.919,0,0,0,.3-.973,1.11,1.11,0,0,0-.433-.868,2.732,2.732,0,0,0-1.12-.543,10.8,10.8,0,0,0-1.3-.25c-.171-.021-.337-.036-.5-.049v-2.4a1.17,1.17,0,1,0-2.34,0V143.2c-.054.013-.108.025-.162.039a5.7,5.7,0,0,0-1.627.708,3.454,3.454,0,0,0-1.215,1.351,4.625,4.625,0,0,0-.084,3.812,3.421,3.421,0,0,0,.972,1.268,8.439,8.439,0,0,0,1.331.856q.729.38,1.448.687t1.321.634a2.947,2.947,0,0,1,.972.824,1.845,1.845,0,0,1,.37,1.131,1.559,1.559,0,0,1-.676,1.374,2.918,2.918,0,0,1-1.691.465,3.387,3.387,0,0,1-1.352-.263,3.1,3.1,0,0,1-.94-.582,7.289,7.289,0,0,0-.676-.582,1.081,1.081,0,0,0-.624-.263,1.045,1.045,0,0,0-.835.5,1.644,1.644,0,0,0-.37.983q0,.972,1.437,1.8a6.282,6.282,0,0,0,2.4.763v2.618a1.17,1.17,0,1,0,2.34,0v-2.667a4.884,4.884,0,0,0,2.349-1.068,4.152,4.152,0,0,0,1.384-3.345,4.757,4.757,0,0,0-.507-2.251,3.946,3.946,0,0,0-1.258-1.469",
    transform: "translate(-126.129 -128.589)",
    fill: "#3ac1ae"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.26224edaf451276fd9b452c7d743c118.svg";
export { ForwardRef as ReactComponent };